import {useGeolocationComposition} from "@/composables/GeolocationComposition";
import {computed} from "vue";
import {useStoreComposition} from "@/composables/StoreComposition";

class TranslationComposition {
    private _headline: string = '';
    private _intro: string = '';
    private _noSuggestSelection: string = '';
    private _noSuggestResults: string = '';
    private _infoAllStores: string = '';
    private _infoRestrictedStores: string = '';
    private _infoNoStores: string = '';
    private _infoLoading: string = '';

    private _distance: string = '';
    private _opening: string = '';
    private _phone: string = '';

    private _placeholder: string = '';
    private _reset: string = '';
    private _browserLocation: string = '';

    private _distanceHeadline: string = '';
    private _regionHeadline: string = '';
    private _typeHeadline: string = '';

    constructor() {
        this._headline = window.storefinder.translations.list.headline;
        this._intro = window.storefinder.translations.list.intro;
        this._noSuggestResults = window.storefinder.translations.list.noSuggestResults;
        this._noSuggestSelection = window.storefinder.translations.list.noSuggestSelection;
        this._infoAllStores = window.storefinder.translations.list.infoAllStores;
        this._infoRestrictedStores = window.storefinder.translations.list.infoRestrictedStores;
        this._infoNoStores = window.storefinder.translations.list.infoNoStores;
        this._infoLoading = window.storefinder.translations.list.infoLoading;

        this._distance = window.storefinder.translations.listItem.distance;
        this._opening = window.storefinder.translations.listItem.opening;
        this._phone = window.storefinder.translations.listItem.phone;

        this._placeholder = window.storefinder.translations.search.placeholder;
        this._reset = window.storefinder.translations.search.reset;
        this._browserLocation = window.storefinder.translations.search.browserLocation;

        this._distanceHeadline = window.storefinder.translations.filter.distanceHeadline;
        this._regionHeadline = window.storefinder.translations.filter.regionHeadline;
        this._typeHeadline = window.storefinder.translations.filter.typeHeadline;
    }

    get headlineTranslation(): string {
        return this._headline;
    }

    get introTranslation() {
        return this._intro;
    }


    get infoLoadingTranslation() {
        return this._infoLoading;
    }

    get noSuggestSelectionTranslation() {
        return this._noSuggestSelection;
    }

    get resetTranslation() {
        return this._reset;
    }

    get distance(): string {
        return this._distance;
    }

    get opening(): string {
        return this._opening;
    }

    get phone(): string {
        return this._phone;
    }

    get placeholderTranslation() {
        return this._placeholder
    }

    get browserLocationTranslation() {
        return this._browserLocation;
    }

    get distanceHeadline(): string {
        return this._distanceHeadline;
    }

    get regionHeadline(): string {
        return this._regionHeadline;
    }

    get typeHeadline(): string {
        return this._typeHeadline;
    }

    infoAllStoresTranslation = computed(() => {
        if(useStoreComposition.stores.length){
            return this._infoAllStores;
        }

        return '';
    })

    infoNoStoresTranslation = computed(() => {
        return this._infoNoStores.replace('{{formattedSearch}}', useGeolocationComposition.formattedSearch);
    })

    infoRestrictedStoresTranslation = computed(() => {
        return this._infoRestrictedStores.replace('{{formattedSearch}}', useGeolocationComposition.formattedSearch);
    })

    noSuggestResultsTranslation = computed(() => {
        return this._noSuggestResults.replace('{{unformattedSearch}}', useGeolocationComposition.unformattedSearch);
    })
}

export const useTranslationComposition = new TranslationComposition();
